<script setup lang="ts">
import { SKILL_LEVEL_MAX } from '~/constants/cvDesign'

/**
 * A skill's level (1–5) as five small dots, the web counterpart of the PDF's
 * `levelDotsHtml`. Filled dots take the text colour, so each template tints
 * them with its own accent class; nothing renders for level 0.
 */
const props = defineProps<{
  level: number
}>()
</script>

<template>
  <span v-if="props.level > 0" class="inline-flex shrink-0 items-center gap-[3px]" role="img" :aria-label="`${props.level}/${SKILL_LEVEL_MAX}`">
    <!-- `<i>`, not `<span>`: pages that colour every span would paint the dots over -->
    <i
      v-for="dot in SKILL_LEVEL_MAX"
      :key="dot"
      class="block size-1.5 rounded-full"
      :class="dot <= props.level ? 'bg-current' : 'bg-current opacity-25'"
    />
  </span>
</template>
